module.exports = __webpack_public_path__ + "img/Dai2-ns.ecb3d033.png";